import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginComponent from './components/Login/Login';
import BalanceComponent from './components/Balance/Balance';

const App = () => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [code, setCode] = useState(false);

  

  const handleLoginSuccess = (code) => {
    setLoggedIn(true);
    setCode(code);
  };

  return (
 //   <BalanceComponent data={code}/>
    
    <Router basename="/survey">
      <Routes>
        <Route exact path="/" element={loggedIn ? <Navigate to="/balance" /> : <LoginComponent onLoginSuccess={handleLoginSuccess} />} />
        <Route path="/balance" element={loggedIn ? <BalanceComponent data={code}/> : <Navigate to="/" />} />
      </Routes>
    </Router>
    
  );
};

export default App;
